module.exports = __webpack_public_path__ + "img/right-arrow-unselected.a64b2d03.svg";